<template>
  <div
    :id="`addProductPressArticleModal-${id}`"
    tabindex="-1"
    aria-hidden="true"
    class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
  >
    <div class="relative p-4 w-full max-w-2xl h-full md:h-auto">
      <!-- Modal content -->
      <div class="relative p-4 bg-white rounded-lg shadow  sm:p-5">
        <!-- Modal header -->
        <div
          class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 "
        >
          <h3 class="text-lg font-semibold text-gray-900 ">
            {{ labels['TITLE_MAIN'][lg] }}
          </h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
            :data-modal-toggle="`addProductPressArticleModal-${id}`"
          >
            <svg
              aria-hidden="true"
              class="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="sr-only"> {{ labels['LABEL_CLOSE'][lg] }}</span>
          </button>
        </div>
        <!-- Modal body -->
        <form action="#">
          <div class="grid gap-4 mb-4  ">
            <div>
              <label
                for="competition"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                {{ labels['LABEL_PRESS_MEDIA'][lg] }} </label>



              <select
                id="media"
                v-model="output.media"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              >
                <option
                  v-for="item in medias[lg]"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div>
              <label
                for="years"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                {{ labels['LABEL_PRESS_YEAR'][lg] }}
              </label>


              <select
                id="years"
                v-model="output.year"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5      "
              >
                <option
                  v-for="year in years"
                  :key="year.id"
                  :value="year.id"
                >
                  {{ year.id }}
                </option>
              </select>
            </div>

            <div class="sm:col-span-2">
              <label class="block mb-2 text-sm font-medium text-gray-900 ">

                {{ labels['LABEL_PRESS_TITLE'][lg] }} </label>

              <input
                id="name"
                v-model="output.name"
                type="text"
                name="name"
                class="sm:col-span-2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                placeholder=""
              >
            </div>

            <div class="sm:col-span-2">
              <label
                for="prices"
                class="block mb-2 text-sm font-medium text-gray-900 "
              >
                {{ labels['LABEL_PRESS_BODY'][lg] }}
              </label>


              <form>
                <div
                  class="w-full  border border-gray-200 rounded-lg bg-gray-50  "
                >
                  <div
                    class="flex items-center justify-between px-3 py-2 border-b "
                  >
                    <div
                      class="flex flex-wrap items-center divide-gray-200 sm:divide-x "
                    >
                      <div class="flex items-center space-x-1 sm:pr-4">
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Attach file</span>
                        </button>
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Embed map</span>
                        </button>
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Upload image</span>
                        </button>
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Format code</span>
                        </button>
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Add emoji</span>
                        </button>
                      </div>
                      <div class="flex flex-wrap items-center space-x-1 sm:pl-4">
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Add list</span>
                        </button>
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Settings</span>
                        </button>
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Timeline</span>
                        </button>
                        <button
                          type="button"
                          class="p-2 text-gray-500 rounded cursor-pointer hover:text-gray-900 hover:bg-gray-100   "
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <span class="sr-only">Download</span>
                        </button>
                      </div>
                    </div>
                    <button
                      type="button"
                      data-tooltip-target="tooltip-fullscreen"
                      class="p-2 text-gray-500 rounded cursor-pointer sm:ml-auto hover:text-gray-900 hover:bg-gray-100   "
                    >
                      <svg
                        aria-hidden="true"
                        class="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 11-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 010-2h4a1 1 0 011 1v4a1 1 0 01-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 012 0v1.586l2.293-2.293a1 1 0 111.414 1.414L6.414 15H8a1 1 0 010 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 010-2h1.586l-2.293-2.293a1 1 0 111.414-1.414L15 13.586V12a1 1 0 011-1z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <span class="sr-only">Full screen</span>
                    </button>
                    <div
                      id="tooltip-fullscreen"
                      role="tooltip"
                      class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip "
                    >
                      Show full screen
                      <div
                        class="tooltip-arrow"
                        data-popper-arrow
                      />
                    </div>
                  </div>
                  <div class="px-4 py-2 bg-white rounded-b-lg ">
                    <label
                      for="editor"
                      class="sr-only"
                    >Publish post</label>
                    <textarea
                      id="editor"
                      v-model="output.text"
                      rows="8"
                      class="block w-full px-0 text-sm text-gray-800 bg-white border-0  focus:ring-0  "
                      placeholder="Write an article..."
                      required
                    />
                  </div>
                </div>
              </form>
            </div>
            <div class="sm:col-span-2">
              <label class="block mb-2 text-sm font-medium text-gray-900 ">
                {{ labels['LABEL_PRESS_WEB'][lg] }}
              </label>

              <input
                id="name"
                v-model="output.url"
                type="text"
                name="name"
                class=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                placeholder=""
              >
            </div>
            <div class="sm:col-span-2 mb-4">
              <label
                class="block mb-2 text-sm font-medium text-gray-900 "
                for="file_input_press"
              >
                {{ labels['LABEL_PRESS_FILE'][lg] }}
              </label>
              <input
                id="file_input_press"
                ref="file_input_press"
                class=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5      "
                class2="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50  focus:outline-none   "
                aria-describedby="file_input_help"
                type="file"
              >
              <p
                id="file_input_help"
                class="hidden mt-1 text-sm text-gray-500 "
              >
                PDF,
                WORD, PNG
                etc...
              </p>
            </div>
          </div>
          <div class="flex items-center justify-end space-x-4">
            <button
              type="button"
              :data-modal-toggle="`addProductPressArticleModal-${id}`"
              class="text-gray-800 bg-primary-700   focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center   "
            >
              {{ labels['LABEL_BUTTON_CANCEL'][lg] }}
            </button>
            <button
              type="button"
              :data-modal-toggle="`addProductPressArticleModal-${id}`"
              class="text-white bg-gray-800 font-bold inline-flex items-center hover:text-white border     focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center     "
              @click="onValidate"
            >
              {{ labels['LABEL_BUTTON_VALIDATE'][lg] }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>

    import axios from "axios";

    import labels from "@/assets/lg/products.json"




    export default {
        name: 'ContentFileListModalPress',
        props: {
            id: String 
        },
        
         
        data() {
            return {
                labels: labels,
                isLoading: false,
                lg: "FR",
                medias: {
                    "EN": [{ "id": "tv", "name": "TV" }, { "id": "radio", "name": "Radio" }, { "id": "web", "name": "Web" }, { "id": "press", "name": "Press" }, { "id": "other", "name": "Other" }],
                    "FR": [{ "id": "tv", "name": "Télévision" }, { "id": "radio", "name": "Radio" }, { "id": "web", "name": "Web" }, { "id": "press", "name": "Presse" }, { "id": "other", "name": "Autre" }]
                },
 
                output: {
                   
                },

                years: [],
            }
        },
        methods: {

            onValidate() {
                this.$emit("validate", this.output)
            },
           
            onFileChange() {

            

                this.isLoading = true;

                this.filelist = [...this.$refs['dropzone-file-document'].files];
            
                if (this.filelist.length > 0) {
                    // this.SetLoadingMyLots(true)
                    // this.$emit("showList", false);
                
                    const formData = new FormData();
                    formData.append("image", this.filelist[0]); // appending file
                    // sending file to the backend
                    // "https://mdw-pvalette.vercel.app/api/lots/upload"
                    // "http://localhost:3000/api/lots/upload"

                    axios
                        .post("/api/images/upload", formData, {
                            headers: { "content-type": "multipart/form-data" },
                        })
                        .then((res) => {
                
                            this.output.document = res.data
                

                            this.filelist = [];

                            // this.$refs.form.reset();

               
                            //this.SetLoadingMyLots(false)
                            this.isLoading = false;
                            // this.displayModal(false)
                            //  this.showModal2 = !this.showModal2;
                        })
                        .catch((err) => {
                      
                            console.log("ERROR =========================", err);
                        });
                }
            },

        },
    }
</script>